export default __webpack_public_path__ + "static/media/Space_02.801a9ea5.png";